// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"11931cba","286":"a8770ed5","453":"1eb5cc81","687":"eec4b7b3","750":"05bba027"}[chunkId] + ".chunk.js";
};